import { NumberOperator, type PropertyCondition } from "src/types/visual";

export const DEFAULT_CATALOG_RANK_TOP_N = 5;

type CatalogRankCondition = {
  operator: NumberOperator.LessThanOrEqualTo;
  value: number;
};

/** A catalog trait compiles to the best rank among matching items, so the only meaningful filter is rank <= N.
 * Any other shape, such as the percentile range the propensity filter writes, resets to the default N. */
export const normalizeCatalogRankCondition = (
  condition: Pick<PropertyCondition, "operator" | "value">,
): CatalogRankCondition => {
  const { value } = condition;
  const isValidTopN =
    typeof value === "number" && Number.isInteger(value) && value >= 1;
  return {
    operator: NumberOperator.LessThanOrEqualTo,
    value: isValidTopN ? value : DEFAULT_CATALOG_RANK_TOP_N,
  };
};
